import alt from '../alt';
import Immutable from 'seamless-immutable';
import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils/index';
import root from 'window-or-global';

const euCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT',
    'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB'];

@seamlessImmutable
class AppConfigStore {
    getStateFunctions() {
        return {
            getDownloadUrl() {
                if (root._epicGamesNav && root._epicGamesNav.browser && root._epicGamesNav.browser.mac) {
                    return this.macDownloadUrl;
                }
                return this.pcDownloadUrl;
            },
            isEu() {
                return euCountries.indexOf(this.country) >= 0;
            },
            checkGameLaunched() {
                let match = false;
                const crtCountry = this.country;
                const launchedCountries = this.launchedCountries.asMutable({deep: true});
                const launcherCountriesInfo = launchedCountries.countryLaunchedInfo;

                if (launcherCountriesInfo) {
                    for (const country of launcherCountriesInfo) {
                        if (crtCountry === country.countryCode) {
                            match = true;
                        }
                    }
                }
                return match;
            },
            checkGameUnavailable() {
                let match = false;
                const crtCountry = this.country;
                const {unavailableCountries} = this;

                if (unavailableCountries.countryCode) {
                    for (const country of unavailableCountries.countryCode) {
                        if (crtCountry === country) {
                            match = true;
                        }
                    }
                }
                return match;
            }
        };
    }

    constructor() {
        this.on('error', (error) => {console.error(error);});
        this.on('bootstrap', seamlessBootstrap.bind(this, null));
        const initialState = Immutable({
            pcDownloadUrl: null,
            macDownloadUrl: null,
            motdSlug: null,
            isPrerender: false,
            euCookieMessage: {},
            country: '',
            launchedCountries: {},
            unavailableCountries: {}
        });
        this.state = initialState.merge(this.getStateFunctions());
    }
}

export default alt.createStore(AppConfigStore, 'AppConfigStore');
